import { render, staticRenderFns } from "./v_Ongoing_Status.vue?vue&type=template&id=0e0fc35b&scoped=true&"
import script from "./v_Ongoing_Status.vue?vue&type=script&lang=js&"
export * from "./v_Ongoing_Status.vue?vue&type=script&lang=js&"
import style0 from "./v_Ongoing_Status.vue?vue&type=style&index=0&id=0e0fc35b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0fc35b",
  null
  
)

export default component.exports